import { eAsnState } from '../../../enums/eAsnState'
import { eTypeAsnIncome } from '../../../enums/eTypeAsnIncome'
import { FilterOption } from '../../_WMS/FilterComponent'
import { Filter } from '../../../types/filters'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'asnId',
    label: 'ID',
    type: 'numeric'
  },
  {
    order: 2,
    key: 'asnNumber',
    label: 'ASN',
    type: 'text'
  },
  {
    order: 3,
    key: 'workOrderId',
    label: 'ID OT',
    type: 'numeric'
  },
  {
    order: 4,
    key: 'typeAsnIncomeId',
    keyfilter: [
      `${eTypeAsnIncome.Reverse}`,
      `${eTypeAsnIncome.UndeliverableOrder}`,
      `${eTypeAsnIncome.Restocking}`
    ], // muestra solo:  2=inversa/ 3=imposible entrega/ 4=reabastecimiento
    label: 'Tipo Ingreso',
    type: 'precreated'
  },
  {
    order: 5,
    key: 'externalOrderId',
    label: 'ID de Pedido',
    type: 'text'
  },
  {
    order: 6,
    key: 'warehouseId',
    label: 'Almacén',
    type: 'precreated'
  },
  {
    order: 7,
    key: 'dateRange',
    label: 'Rango de Fechas Recepción',
    type: 'daterange',
    canBeRepeated: false
  },
  {
    order: 8,
    key: 'brandId',
    label: 'Marca',
    type: 'precreated'
  },
  {
    order: 9,
    key: 'trackingNumber',
    label: 'Tracking number',
    type: 'text'
  },
  {
    order: 10,
    key: 'asnStateId',
    keyfilter: [
      `${eAsnState.Controlled}`,
      `${eAsnState.Finished}`,
      `${eAsnState.Cancelled}`,
      `${eAsnState.Pending}`
    ],
    label: 'Estado Asn',
    type: 'precreated',
    canBeRepeated: true
  }
]

export const defaultFilters: Filter[] = [
  {
    key: 'asnStateId',
    value: eAsnState.Controlled,
    label: 'Estado',
    displayValue: 'Controlado'
  }
]
